import { modal } from '../common/_modal';

export const aboutFunc = () => {
  // モーダルウィンドウ
  window.addEventListener('load', () => setTimeout(modal, 1000));
};
